import { get, getOr } from 'lodash/fp';
import { parseInt } from '../utils';

const portalValue = (otherInfo, portalField, fallback) => {
  const value = get(portalField, otherInfo);
  return value === undefined ? fallback : value;
};

export default guest => {
  const otherInfo = getOr({}, 'publicUser.otherInfo', guest);
  if (!get('publicUser', guest)) {
    return guest;
  }

  const homeless = get('homeless', otherInfo);
  return {
    ...guest,
    street_address: portalValue(
      otherInfo,
      'streetAddress',
      guest.street_address
    ),
    apartment: portalValue(otherInfo, 'apartment', guest.apartment),
    city: portalValue(otherInfo, 'city', guest.city),
    state: portalValue(otherInfo, 'state', guest.state),
    zipcode: portalValue(otherInfo, 'zipCode', guest.zipcode),
    county: portalValue(otherInfo, 'county', guest.county),
    homeless: homeless === undefined ? guest.homeless : parseInt(homeless),
    phone: portalValue(otherInfo, 'homePhone', guest.phone),
    workphone: portalValue(otherInfo, 'workPhone', guest.workphone),
    cellphone: portalValue(otherInfo, 'cellPhone', guest.cellphone)
  };
};
